import React from 'react';
import Picture from "../../../shared/components/Picture";
import { formatImageUrl } from "../../../shared/utils";
import { useReactAppState } from "../../../shared/containers/utils";

const Club = ({ clubData, isHome, isWinner, showShortName = false, showAbbreviation = false }) => {
  const { mediaQueries } = useReactAppState();

  const { isMediumLargeMin } = mediaQueries || {};

  const { abbreviation, fullName, shortName, logoColorUrl } = clubData || {};
  const availableShortName = shortName ? shortName : fullName;
  const isHomeModifierClass = `mls-o-match-strip__club--${isHome ? 'home' : 'away'}`;
  const isWinnerModifierClass = `${isWinner ? 'mls-o-match-strip__club--winner' : ''}`;
  if (!abbreviation && !availableShortName) {
    return null;
  }

  const { highQuality } = logoColorUrl ? formatImageUrl(logoColorUrl, { format: "w_128,h_128,c_pad", extension: "f_png" }) : { highQuality: "/assets/images/Fallbacklogo-grey.png" };

  return (
    <div className={`mls-o-match-strip__club ${isHomeModifierClass} ${isWinnerModifierClass}`}>
      <div className="mls-o-match-strip__club-name">
        <span className="mls-o-match-strip__club-logo">
            <Picture
              src={highQuality}
              title={name}
              role="presentation"/>
          </span>
        {
          showAbbreviation
            ? (
              <span className="mls-o-match-strip__club-abbreviation">
                {abbreviation}
              </span>
            ) : isMediumLargeMin || showShortName
              ? (
                <span className="mls-o-match-strip__club-short-name">
                  {availableShortName}
                </span>
              )
              :
              (
                <span className="mls-o-match-strip__club-abbreviation">
                  {abbreviation}
                </span>
              )
        }
      </div>
    </div>
  );
};

export default Club;
